// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"a51d7b20","177":"edbc3a92","329":"a86adc00"}[chunkId] + ".chunk.css";
};